// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-pdf-content:before{content:\"\";float:left;height:0;padding-top:var(--aspect-ratio)}.page-pdf-content:after{clear:both;content:\"\";display:table}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
